import React from "react";
import { useLottie, Lottie } from "react-lottie-hook";
import animationData from "./assets/data.js";

const LottieLoader = () => {
	const [lottieRef] = useLottie({
		loop: true,
		autoplay: true,
		renderer: "svg",
		rendererSettings: {
			preserveAspectRatio: "xMidYMid slice"
		},
		animationData
	});

	return <Lottie lottieRef={lottieRef} />;
};
export default LottieLoader;
